import React, { useEffect, useState } from "react";
import { RoutesLink } from "../../ApiHelper/RoutesLink";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import Cookies from "js-cookie";
import { callApi } from "../../ApiHelper/ApiHelper";
import { toast } from "react-toastify";
import { Spinner } from "reactstrap";
import { v4 as uuidv4 } from "uuid";
import PasswordIcon from "../../components/Icons/PasswordIcon";
import EyeCloseIcon from "../../components/Icons/EyeCloseIcon";
import EyeOpenIcon from "../../components/Icons/EyeOpenIcon";
import ErrorMessage from "../../components/comman/ErrorMessage";
import { apiUrl } from "../../ApiHelper/ApiUrl";
import EmailIcon from "../../components/Icons/EmailIcon";
import { isSupported, getToken } from "firebase/messaging";
import { messaging } from "../../utility/Firebase/Firebase";
import BgBlurLoader from "../../components/Loaders/BgBlurLoader";

function Login() {
  const navigate = useNavigate();
  const randomDeviceId = uuidv4();
  const [isLoading, setIsLoading] = useState(false);
  const [isFcmLoading, setIsFcmLoading] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    const getMessagingToken = async () => {
      try {
        const supported = await isSupported();

        if (!supported) {
          setIsFcmLoading(false);
          return;
        }

        if (Notification.permission === "granted") {
          await requestToken();
        } else if (Notification.permission === "default") {
          const permission = await Notification.requestPermission();
          if (permission === "granted") {
            await requestToken();
          } else {
            localStorage.setItem("fcmToken", null);
            toast.warn("Please enable notifications to receive updates.");
          }
        } else {
          localStorage.setItem("fcmToken", null);
          toast.error(
            "Notifications are blocked. Please enable them in your browser settings to receive updates.",
          );
        }
      } catch (error) {
        console.error("FCM Flow: Error during initialization:", error);
      } finally {
        setIsFcmLoading(false);
      }
    };

    const requestToken = async () => {
      try {
        if (!import.meta.env.VITE_APP_FIREBASE_KEY) {
          console.error("FCM Flow: REACT_APP_FIREBASE_KEY is missing!");
          return;
        }
        const token = await getToken(messaging, {
          vapidKey: import.meta.env.VITE_APP_FIREBASE_KEY,
        });

        if (token) {
          localStorage.setItem("fcmToken", token);
          // console.log("FCM Flow: Token received:", token);
        } else {
          // console.log("FCM Flow: No registration token available.");
        }
      } catch (error) {
        // console.error("FCM Flow: Error getting token:", error);
      }
    };

    getMessagingToken();
  }, []);

  const onSubmit = (data) => {
    let deviceId = "";
    if (localStorage.getItem("deviceId")) {
      deviceId = localStorage.getItem("deviceId");
    } else {
      deviceId = "2024_" + randomDeviceId;
    }
    localStorage.setItem("deviceId", deviceId);
    const fcmToken = localStorage.getItem("fcmToken");
    const loginData = {
      email: data?.email,
      password: data?.password,
      deviceId: deviceId,
      deviceToken: fcmToken ? fcmToken : null,
      from: "web",
    };
    // console.log("logindata", loginData);
    const options = {
      method: "POST",
      data: loginData,
    };
    let API = apiUrl?.login;
    setIsLoading(true);
    callApi(API, options).then((response) => {
      // console.log("ress>>>>>>>>>>.", response.data);
      setIsLoading(false);
      if (response?.status === true) {
        toast.success(response?.message);
        if (response?.data?.otpRequired === true) {
          navigate(RoutesLink?.verify_otp, {
            state: {
              data: loginData,
              type: "login",
            },
          });
        } else {
          Cookies.set("token", response?.data?.token?.accessToken);
          Cookies.set("refreshToken", response?.data?.token?.refreshToken);
          localStorage.setItem("token", response?.data?.token?.accessToken);
          new BroadcastChannel("auth").postMessage({
            type: "login",
            sourceTabId: window.__TAB_ID,
          });
          navigate(RoutesLink?.dashboard);
        }
      } else {
        toast.error(response?.message);
      }
    });
  };

  return (
    <>
      {/* {isFcmLoading && <BgBlurLoader />} */}
      <div className="login-content bg-white">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-lg-7 col-xl-8 px-0">
              <div className="login-img-card">
                <img src={"/assets/img/solar-bg.avif"} alt="login-solar-bg" />
              </div>
            </div>
            <div className="col-12 col-lg-5 col-xl-4 px-0">
              <div className="d-flex align-items-center justify-content-center h-100">
                {/* login card start here... */}
                <div className="card login-card shadow-none">
                  <div className="card-body">
                    <div className="d-flex justify-content-center my-5">
                      <div
                        className="bg-white p-2 p-md-4 rounded-5 shadow-sm"
                        style={{ maxWidth: "500px", width: "100%" }}
                      >
                        <img
                          src={
                            import.meta.env.BASE_URL +
                            "assets/img/Shreenath Blue Logo.png"
                          }
                          alt="Shreenath Logo"
                          className="img-fluid d-block mx-auto"
                          style={{ maxHeight: "80px", objectFit: "contain" }}
                        />
                      </div>
                    </div>
                    <h1 className="title">Login</h1>
                    <p className="fs-5 mb-5">Access to our Dashboard</p>
                    <form onSubmit={handleSubmit(onSubmit)}>
                      <div className="form-group mb-3">
                        <label htmlFor="mobile_num" className="form-label">
                          Email
                        </label>
                        <div className="position-relative icon-input">
                          <input
                            type="text"
                            className="form-control"
                            id="mobile_num"
                            name="mobile"
                            placeholder="Enter Email"
                            {...register("email", {
                              required: "Please fill in your email",
                              pattern: {
                                value:
                                  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i,
                                message: "Invalid email address",
                              },
                            })}
                            onChange={(e) => {
                              const trimmedEmail = e.target.value
                                .trim()
                                .toLowerCase();
                              setValue("email", trimmedEmail, {
                                shouldValidate: true,
                              });
                            }}
                            onBlur={(e) => {
                              const trimmedEmail = e.target.value.trim();
                              setValue("email", trimmedEmail, {
                                shouldValidate: true,
                              });
                            }}
                          />

                          <EmailIcon />
                        </div>
                        <ErrorMessage message={errors?.email?.message} />
                      </div>
                      <div className="form-group mb-3">
                        <label htmlFor="login_password" className="form-label">
                          Password
                        </label>
                        <div className="position-relative icon-input">
                          <input
                            type={showPassword ? "text" : "password"}
                            name="password"
                            className="form-control"
                            id="login_password"
                            placeholder="Enter Password"
                            {...register("password", {
                              required: "Please enter a valid password",
                            })}
                          />
                          <PasswordIcon />
                          <div className="password-show">
                            <div
                              type="button"
                              className=""
                              onClick={togglePasswordVisibility}
                              style={{ fontSize: "14px" }}
                            >
                              {showPassword ? (
                                <EyeOpenIcon />
                              ) : (
                                <EyeCloseIcon />
                              )}
                            </div>
                          </div>
                        </div>
                        <ErrorMessage message={errors?.password?.message} />
                      </div>
                      <div className="d-flex align-items-center justify-content-end mb-5">
                        {/* <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          defaultValue=""
                          id="rememberMe"
                        />
                        <label
                          className="form-check-label fs-14"
                          htmlFor="rememberMe"
                        >
                          Remember me
                        </label>
                      </div> */}
                        <div
                          className="btn btn-link text-decoration-none fs-14 p-0 text-primary"
                          onClick={() => {
                            navigate(RoutesLink?.forgot_password);
                          }}
                        >
                          Forget Password ?
                        </div>
                      </div>
                      <div className="d-grid gap-4 btns">
                        <button
                          disabled={isLoading}
                          type="submit"
                          className="btn btn-primary w-100 fs-4 fw-bold text-white"
                        >
                          {isLoading ? <Spinner /> : "Log In"}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
                {/* login card end here... */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Login;
